module.exports = __webpack_public_path__ + "static/media/del-icon-taskprops.5792c12e.svg";